<template>
  <div id="login" v-bind:style="{backgroundImage:'url(' + serve  + banner + ')'}">
    <div class="jacket container">
      <div class="form">
        <div class="jacket2">
          <div class="title">用户登录</div>
          <el-alert v-if="error.length>0" :title="error" type="error" effect="dark"></el-alert>
          <div class="input-row">
            <bio-input v-model="mobile" placeholder="请输入手机号" :error="err1" :errorTxt="txt1"></bio-input>
            <i class="iconfont icon-mobile icon_posi"></i>
          </div>
          <!--  @keyup.enter.native="login()" -->
          <div class="input-row">
            <bio-input
              v-model="password"
              placeholder="请输入密码"
              :error="err2"
              :errorTxt="txt2"
              type="password"
            ></bio-input>
            <i class="iconfont icon-lock icon_posi"></i>
          </div>
          <!--  -->
          <div>
            <button class="sumbit" @click="login()" :loading="loading">登录</button>
          </div>

          <div>
            <span>
              <router-link to="/forget" class="forget">忘记密码</router-link>
            </span>
            <span>
              <router-link to="/register" class="register">新用户注册</router-link>
            </span>
          </div>
          <div class="text-line"></div>
          <div class="text">
            <span>其他方式登录</span>
          </div>

          <div>
            <el-row>
              <el-col :span="6" :offset="6">
                <div class="login-item" @click="wx">
                  <div style="margin-bottom:10px;">
                    <i class="iconfont icon-weixin" style="font-size:28px"></i>
                  </div>
                  <div>微信</div>
                </div>
              </el-col>

              <el-col :span="6">
                <div class="login-item" @click="qq">
                  <div style="margin-bottom:10px;">
                    <i class="iconfont icon-qq" style="font-size:28px"></i>
                  </div>
                  <div>QQ</div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bioInput from "../../components/bioInput.vue";
export default {
  components: { bioInput },
  data() {
    return {
      //
      serve: this.$store.state.serve,

      mobile: "",
      password: "",
      err1: false,
      txt1: "",
      err2: false,
      txt2: "",
      loading: false,
      banner: "",
      error: ""
    };
  },
  mounted() {},
  created() {
    this.axios.get(this.serve + "/get_banner?type=login").then(res => {
      this.banner = res.data.data.image;
    });
    var _self = this;
    document.onkeydown = function(e) {
      var key = window.event.keyCode;
      if (key == 13) {
        _self.login();
      }
    };
  },
  methods: {
    qq() {
      window.location.href = this.serve + "/qqLogin";
    },
    wx() {
      window.location.href = this.serve + "/weChatLogin";
    },
    login() {
      var that = this;
      this.loading = true;
      this.axios
        .get(this.serve + "/login", {
          params: { mobile: this.mobile, password: this.password }
        })
        .then(res => {
          this.loading = false;
          if (res.data.status == "success") {
            this.$store.state.isLogin = true;
            this.$cookies.set("token", res.data.token);
            this.$cookies.set("user", res.data.mobile);
            if (
              this.$cookies.get("returnPath") == "/login" ||
              this.$cookies.get("returnPath") == "/register"
            ) {
              this.$router.push("/");
            } else {
              this.$router.push(that.$cookies.get("returnPath"));
            }
          } else {
            if (res.data.msg == "未知错误") {
              this.error = "登录失败";
            } else {
              this.error = res.data.msg;
            }
          }
        });
    },
    reSetErr() {
      this.err1 = false;
      this.txt1 = "";
      this.err2 = false;
      this.txt2 = "";
    }
  }
};
</script>
<style lang="scss">
#login {
  background-position: center;
  background-size: auto 100%;
  height: 540px;
  padding: 70px 0 30px 0;
  .title {
    font-size: 18px;
    color: #e2211c;
    text-align: center;
    padding: 20px 0;
    margin-bottom: 10px;
  }
  .jacket {
    .login-item {
      color: #ddd;
      text-align: center;
      font-size: 14px;
      padding: 0 10px;
    }
    .login-item:hover {
      color: #e2211c;
      cursor: pointer;
    }
    .sumbit {
      background-color: #e2211c;
      display: block;
      padding: 15px 0;
      width: 100%;
      border: 0;
      color: #fff;
      margin-bottom: 20px;
      cursor: pointer;
    }
    text-align: right;
    .form {
      .text {
        text-align: center;
        color: #999;
        position: relative;
        top: -8px;
        margin-bottom: 20px;
        span {
          background-color: #fff;
          width: 150px;
          display: inline-block;
        }
      }
      .text-line {
        height: 1px;
        background-color: #999;
        margin-top: 30px;
      }
      a {
        color: #58a9df;
        font-size: 12px;
      }
      background-color: #fff;
      display: inline-block;
      .jacket2 {
        padding: 40px 40px;
        .input-row {
          padding: 10px 0;
          width: 280px;
          position: relative;
          .icon_posi {
            color: #cccccc;
            font-size: 26px;
            position: absolute;
            left: 7px;
            top: 17px;
          }
          .icon {
            color: #dddddd;
          }
          .form-item {
            float: left;
            display: block;
          }
        }
        .input-row::after {
          content: "";
          display: block;
          clear: both;
        }
      }
      .forget {
        float: left;
      }
    }
  }
}
</style>